import { Component, ViewChild, OnInit } from '@angular/core';
import { NgbCarousel, NgbSlideEvent, NgbSlideEventSource, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';



interface Certificate {
  name: string;
  provider: string;
  link: string;

}

const CERTIFICATES: Certificate[] = [
  {
    name: 'Data Science Methodology',
    provider: 'IBM',
    link: "https://courses.cognitiveclass.ai/certificates/2763acb81f1c4248bf07fbe3a1d35179",

  },
  {
    name: 'Sentiment Analysis on Tunisian Google Play Store',
    provider: 'Zindi',
    link: "https://zindi.africa/users/AnasCharfi/competitions/certificate",

  },
  {
    name: 'ML Hackathon',
    provider: 'DSC Tunisia',
    link: "",

  },


];


@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit {

  trency_images = [
    "/assets/images/portfolio/dev/trency/training.PNG",
    "/assets/images/portfolio/dev/trency/prediction.PNG",
    "/assets/images/portfolio/dev/trency/convertir_devise.png",
    "/assets/images/portfolio/dev/trency/evolution_bourse.png",
    
  ];

  terrainet_images = [
    "/assets/images/portfolio/dev/TerraiNet/Gestion_terrains.png",
    "/assets/images/portfolio/dev/TerraiNet/Maps_terrain.png",
    "/assets/images/portfolio/dev/TerraiNet/List_Categories.png",
    "/assets/images/portfolio/dev/TerraiNet/ajouter_categ_admin.png",
    "/assets/images/portfolio/dev/TerraiNet/acceuil_admin.png",
    "/assets/images/portfolio/dev/TerraiNet/Filter.png",
    "/assets/images/portfolio/dev/TerraiNet/admin_gestion_category.png",
    "/assets/images/portfolio/dev/TerraiNet/admin_gestion_terrain.png",
    "/assets/images/portfolio/dev/TerraiNet/Tous_terrains.png",
    "/assets/images/portfolio/dev/TerraiNet/Un_terrain.png",
    "/assets/images/portfolio/dev/TerraiNet/Vos_terrains.png",

  ]

  paused = false;
  unpauseOnArrow = false;
  pauseOnIndicator = false;
  pauseOnHover = false;
  pauseOnFocus = true;

  @ViewChild('carousel', { static: true }) carousel: NgbCarousel;

  togglePaused() {
    if (this.paused) {
      this.carousel.cycle();
    } else {
      this.carousel.pause();
    }
    this.paused = !this.paused;
  }

  onSlide(slideEvent: NgbSlideEvent) {
    if (this.unpauseOnArrow && slideEvent.paused &&
      (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)) {
      this.togglePaused();
    }
    if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
      this.togglePaused();
    }
  }




  constructor() {

  }


  ngOnInit(): void {

  }

  certificates = CERTIFICATES;

}
